import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
} from "@chakra-ui/react";
import React from "react";

export default function Category(props: {
  categoryName: string;
  children: React.ReactNode;
}) {
  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex='1' textAlign='left' fontWeight='bold'>
            {props.categoryName}
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4} px={"auto"}>
        <Box
          display='flex'
          alignItems={"center"}
          justifyContent={["center", "start", "start"]}
          flexDir={"row"}
          p='0'
          pb='10px'
          w='100%'
          flexWrap={"wrap"}>
          {props.children}
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
}
